// extracted by mini-css-extract-plugin
module.exports = {"flashNewsTit":"index_flashNewsTit__0wcU2","tabsCon":"index_tabsCon__o22xG","tabsConBox":"index_tabsConBox__wjIE4"};